import Vue from 'vue'
import Vuex from 'vuex'
import VueCookies from 'vue-cookies'
import {getUserInfo} from "../restful/api";
Vue.use(Vuex);
let store = new Vuex.Store({
	state:{
	//	userInfo:{},//存储是为了防止数据丢失
		 userInfo:{},//存储是为了防止数据丢失
		count:1,
	},
	// 修改state的唯一方法 是提交mutations
	mutations:{
		SetUserInfo(state,user){
			
			state.userInfo = user;
		},
		addcount(state){
			
			state.count = state.count+1;
			console.log(state.count)
		},
	},
  getters: {
    //get方法
    getUserInfo: state => state.userInfo

  },
	actions:{
    SetUserInfo({commit},user){
	
			commit('SetUserInfo',user);
		},
		addcount({commit}){
			console.log("aaa")
				commit('addcount');
			},
	}
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js